import {createApp} from 'vue';
import Archive from "../vue/Archive.vue";

const createVueArchive = (id) => {
  const element = document.getElementById( id );

  if (!element) {
    return;
  }

  const props = {};

  if (!!element.dataset.perPage) {
    props.perPage = parseInt( element.dataset.perPage );
  }

  if (!!element.dataset.amountVisibleFilters) {
    props.amountVisibleFilters = parseInt( element.dataset.amountVisibleFilters );
  }

  if (!!element.dataset.labels) {
    props.labels = JSON.parse( element.dataset.labels );
  }

  if (!!element.dataset.endpoint) {
    props.endpoint = JSON.parse( element.dataset.endpoint );
  }

  if (!!element.dataset.hideDateFilters) {
    props.hideDateFilters = Boolean( element.dataset.hideDateFilters );
  }

  if (!!element.dataset.showCount) {
    props.showCount = Boolean( element.dataset.showCount );
  }

  if (!!element.dataset.showSearchForm) {
    props.showSearchForm = Boolean( element.dataset.showSearchForm );
  }

  if (!!element.dataset.showSearchTerm) {
    props.showSearchTerm = Boolean( element.dataset.showSearchTerm );
  }

  if (!!element.dataset.showDocuments) {
    props.showDocuments = Boolean( element.dataset.showDocuments );
  }

  if (!!element.dataset.orderby) {
    props.orderby = element.dataset.orderby;
  }

  if (!!element.dataset.order) {
    props.order = element.dataset.order;
  }

  createApp( Archive, props ).mount( element );
}

export default createVueArchive;
